import { supabase } from "./../supabaseClient";

export async function getOfficeInfo() {
  const { data, error } = await supabase
    .from("office")
    .select("*")

  if (error) throw error;

  return data;
}

export async function getPublications() {
  const { data, error } = await supabase
    .from("publications")
    .select("*")

  if (error) throw error;

  return data;
}

export async function getLeadership() {
  const { data, error } = await supabase
    .from("leadership")
    .select("*")
    .order("id", { ascending: false });

  if (error) throw error;

  return data;
}

export async function getMentorship() {
  const { data, error } = await supabase
    .from("mentorship")
    .select("*")
    .order("id", { ascending: false });

  if (error) throw error;

  return data;
}

export async function getTeaching() {
  const { data, error } = await supabase
    .from("teaching")
    .select("*")

  if (error) throw error;

  return data;
}

export async function getTalks() {
  const { data, error } = await supabase
    .from("talks")
    .select("*")
    .order("date", { ascending: false });

  if (error) throw error;

  return data;
}

export async function getAttendance() {
  const { data, error } = await supabase
    .from("attendance")
    .select("*")
    .order("id", { ascending: false });

  if (error) throw error;

  return data;
}

export async function getRecognitions() {
  const { data, error } = await supabase
    .from("recognitions")
    .select("*")
    .order("id", { ascending: true });

  if (error) throw error;

  return data;
}